/* FTF THE FRINGE — storefront interactions. No external JS libraries. */
(() => {
  const get = (selector, root=document) => root.querySelector(selector);
  const getAll = (selector, root=document) => [...root.querySelectorAll(selector)];
  const init = (root=document) => {
    getAll('[data-ftf-header]', root).forEach(header => {
      const toggle=get('[data-ftf-menu-toggle]',header), menu=get('[data-ftf-menu]',header);
      if(!toggle||!menu||toggle.dataset.ready)return;
      toggle.dataset.ready='true';
      toggle.addEventListener('click',()=>{
        const open=menu.classList.toggle('is-open');toggle.setAttribute('aria-expanded',String(open));
      });
      menu.addEventListener('click',e=>{if(e.target.closest('a')){menu.classList.remove('is-open');toggle.setAttribute('aria-expanded','false');}});
      document.addEventListener('keydown',e=>{if(e.key==='Escape'){menu.classList.remove('is-open');toggle.setAttribute('aria-expanded','false');}});
    });
    getAll('[data-ftf-auto-submit]',root).forEach(select=>{if(select.dataset.ready)return;select.dataset.ready='true';select.addEventListener('change',()=>select.form?.requestSubmit());});
    getAll('[data-ftf-gallery-thumb]',root).forEach(button=>{
      if(button.dataset.ready)return;button.dataset.ready='true';
      button.addEventListener('click',()=>{
        const gallery=button.closest('.ftf-product-gallery');const image=get('.ftf-main-image',gallery);
        if(!image)return;
        image.src=button.dataset.image;image.srcset='';image.alt=button.dataset.alt||'';
        getAll('[data-ftf-gallery-thumb]',gallery).forEach(b=>b.classList.toggle('is-active',b===button));
      });
    });
    getAll('[data-ftf-variant-select]',root).forEach(select=>{
      if(select.dataset.ready)return;select.dataset.ready='true';
      select.addEventListener('change',()=>{
        const option=select.selectedOptions[0];if(!option)return;
        const panel=select.closest('.ftf-product-detail');if(!panel)return;
        const price=get('[data-ftf-product-price]',panel), add=get('[data-ftf-add-button]',panel);
        if(price)price.textContent=option.dataset.price||'';
        if(add){add.disabled=option.disabled;add.textContent=option.disabled?'SOLD OUT':'ADD TO CART ↗';}
        const image=get('.ftf-main-image',panel);
        if(image&&option.dataset.image){image.src=option.dataset.image;image.srcset='';}
      });
    });
    getAll('[data-ftf-share]',root).forEach(button=>{
      if(button.dataset.ready)return;button.dataset.ready='true';
      button.addEventListener('click',async()=>{
        const share={title:document.title,url:window.location.href};
        try{if(navigator.share){await navigator.share(share);return;}if(navigator.clipboard){await navigator.clipboard.writeText(share.url);const original=button.textContent;button.textContent='LINK COPIED ✓';setTimeout(()=>button.textContent=original,2200);return;}}catch(e){if(e.name==='AbortError')return;}
        window.prompt('Copy this link',share.url);
      });
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
